module.exports = __webpack_public_path__ + "img/Ca-studio.5a541508.gif";